interface WaitingMessageLike {
  senderType: string
  metadataType?: string | null
}

/**
 * A twin (or George) message ends the guest "waiting for a twin" state. A
 * display message (`audience_plot`) does not: the chart can land before any
 * twin has answered the turn.
 */
export function endsWaitingForReply(message: WaitingMessageLike): boolean {
  if (message.metadataType === 'audience_plot') {
    return false
  }
  return message.senderType === 'twin' || message.senderType === 'george'
}
